
<div class="content-header d-flex justify-content-between">
  <div class="d-flex flex-row align-items-center">
      <fa-icon  [icon]='faCloud'></fa-icon>
      <p class="ms-2 title">Preview Quotation</p>
  </div>
</div>

<div class="inner-container">

  <div class="d-flex flex-row mt-5 ms-3 mb-2">
    <div class="col">
       
    </div>
  </div>
    <div class="mt-4 flex-row col-12 row">

      <div class="card p-4 shadow">
        <div class="d-flex justify-content-between" >
 <h2>Self-Managed Quotation</h2>
      <a class="navbar-brand">
        <svg  width="150" height="60" viewBox="0 0 162 67" version="1.1" id="Layer_1" xmlns:v="https://vecta.io/nano"
	 xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 191.1 64"
	 style="enable-background:new 0 0 191.1 64;" xml:space="preserve">
<style type="text/css">
	.st0{fill:#0089D4;}
	.st1{fill:#51B345;}
	.st2{fill:#F37946;}
	.st3{fill:#FDB307;}
</style>
<path d="M27.8,5.4l0.8,1.5l-10.3,5.8l-0.8-1.5L27.8,5.4z"/>
<circle class="st0" cx="31.3" cy="4.9" r="4.9"/>
<path d="M12.8,20h1.7v8.8h-1.7V20z M3.1,4.9l1.2-1.2l6.2,6.2l-1.2,1.2L3.1,4.9z"/>
<circle class="st1" cx="13.7" cy="13.3" r="6.7"/>
<circle class="st2" cx="13.7" cy="36.3" r="8.7"/>
<path class="st0" d="M29.9,44.1V14.4h5.9l12.1,19.8V14.4h5.6v29.7h-6l-12-19.4v19.4H29.9z"/>
<path d="M78.8,33.2l5.8,1.8c-0.9,3.2-2.4,5.6-4.4,7.2c-2.1,1.6-4.7,2.4-7.9,2.4c-3.9,0-7.2-1.3-9.7-4s-3.8-6.4-3.8-11
	c0-4.9,1.3-8.8,3.8-11.5c2.6-2.7,5.9-4.1,10.1-4.1c3.6,0,6.6,1.1,8.8,3.2c1.4,1.3,2.4,3.1,3,5.5L78.6,24c-0.3-1.5-1.1-2.8-2.2-3.7
	S74,19,72.4,19c-2.2,0-4,0.8-5.4,2.4c-1.3,1.5-2,4.1-2,7.6c0,3.8,0.7,6.4,2,8s3.1,2.4,5.3,2.4c1.6,0,3-0.5,4.1-1.5
	S78.3,35.3,78.8,33.2L78.8,33.2L78.8,33.2z M94,29.1l-5.2-0.9c0.6-2.1,1.6-3.6,3-4.6s3.5-1.5,6.3-1.5c2.5,0,4.4,0.3,5.7,0.9
	c1.2,0.6,2.1,1.4,2.6,2.3s0.8,2.6,0.8,5.1l-0.1,6.6c0,1.9,0.1,3.3,0.3,4.2s0.5,1.9,1,2.9h-5.6c-0.1-0.4-0.3-0.9-0.5-1.7
	c-0.1-0.3-0.2-0.6-0.2-0.7c-1,0.9-2,1.7-3.1,2.1c-1.1,0.5-2.3,0.7-3.5,0.7c-2.2,0-4-0.6-5.2-1.8c-1.3-1.2-1.9-2.7-1.9-4.6
	c0-1.2,0.3-2.3,0.9-3.2c0.6-1,1.4-1.7,2.4-2.2s2.6-0.9,4.5-1.3c2.7-0.5,4.5-1,5.5-1.4v-0.6c0-1.1-0.3-1.9-0.8-2.3
	c-0.5-0.5-1.6-0.7-3.1-0.7c-1,0-1.8,0.2-2.4,0.6S94.4,28.1,94,29.1L94,29.1L94,29.1z M101.6,33.7c-0.7,0.2-1.9,0.5-3.5,0.9
	c-1.6,0.3-2.6,0.7-3.1,1c-0.7,0.5-1.1,1.2-1.1,2s0.3,1.5,0.9,2.1s1.3,0.9,2.3,0.9c1.1,0,2.1-0.3,2.9-1c0.7-0.5,1.1-1.1,1.4-1.9
	c0.2-0.5,0.2-1.4,0.2-2.8L101.6,33.7L101.6,33.7z M131.6,28.9l-5.6,1c-0.2-1.1-0.6-2-1.3-2.5c-0.7-0.6-1.5-0.9-2.6-0.9
	c-1.4,0-2.6,0.5-3.4,1.5s-1.3,2.6-1.3,4.9c0,2.6,0.4,4.4,1.3,5.4c0.9,1.1,2,1.6,3.5,1.6c1.1,0,2-0.3,2.7-0.9s1.2-1.7,1.5-3.2
	l5.6,0.9c-0.6,2.6-1.7,4.5-3.3,5.8s-3.9,2-6.6,2c-3.1,0-5.7-1-7.5-3c-1.9-2-2.8-4.7-2.8-8.2s0.9-6.3,2.8-8.3s4.4-3,7.6-3
	c2.6,0,4.7,0.6,6.3,1.7C129.8,24.9,130.9,26.6,131.6,28.9L131.6,28.9z M141.6,14.4v10.9c1.8-2.1,4-3.2,6.6-3.2
	c1.3,0,2.5,0.2,3.5,0.7c1.1,0.5,1.8,1.1,2.4,1.9c0.5,0.8,0.9,1.6,1.1,2.5s0.3,2.3,0.3,4.3v12.6h-5.7V32.7c0-2.3-0.1-3.7-0.3-4.3
	s-0.6-1.1-1.1-1.4c-0.5-0.4-1.2-0.5-2.1-0.5s-1.8,0.2-2.5,0.7s-1.3,1.1-1.6,2.1c-0.3,0.9-0.5,2.3-0.5,4.1v10.8H136V14.4H141.6
	L141.6,14.4z M173.7,37.2l5.7,0.9c-0.7,2.1-1.9,3.7-3.5,4.7c-1.6,1.1-3.5,1.6-5.9,1.6c-3.7,0-6.5-1.2-8.3-3.7
	c-1.4-2-2.1-4.4-2.1-7.4c0-3.6,0.9-6.4,2.8-8.4s4.2-3,7.1-3c3.2,0,5.7,1.1,7.6,3.2c1.8,2.1,2.7,5.4,2.7,9.7h-14.3
	c0,1.7,0.5,3,1.4,3.9s2,1.4,3.3,1.4c0.9,0,1.6-0.2,2.2-0.7C172.9,39.1,173.4,38.3,173.7,37.2L173.7,37.2z M174,31.5
	c0-1.7-0.5-2.9-1.3-3.8s-1.8-1.3-3-1.3s-2.3,0.5-3.1,1.4s-1.2,2.1-1.2,3.7L174,31.5L174,31.5z"/>
<circle class="st3" cx="3.4" cy="3.8" r="3.4"/>
<path d="M189.1,10.3c0,4.1-3.1,7-7.2,7c-4.1,0-7.2-3.1-7.2-7s3.1-7,7.2-7C186,3.3,189.1,6.4,189.1,10.3z M176.6,10.3
	c0,3.1,2.3,5.5,5.5,5.5c2.9,0,5.3-2.6,5.3-5.5c0-3.1-2.3-5.5-5.3-5.5S176.6,7.3,176.6,10.3z M181,13.4h-1.5v-6
	c0.5-0.2,1.3-0.2,2.4-0.2c1.1,0,1.6,0.2,2,0.4s0.5,0.7,0.5,1.3c0,0.7-0.5,1.1-1.3,1.5l0,0c0.5,0.2,0.9,0.7,1.1,1.5l0.4,1.5h-1.5
	c-0.2-0.2-0.4-0.7-0.5-1.5c-0.2-0.7-0.5-0.9-1.3-0.9H181V13.4L181,13.4z M181,10.1h0.7c0.7,0,1.5-0.2,1.5-0.9c0-0.5-0.4-0.9-1.3-0.9
	H181V10.1z M109.5,60.7c0-0.4,0.1-1.1,0.1-1.6v-7.7h1.1v4c0.4-0.7,1.1-1.2,2.2-1.2c1.6,0,2.7,1.3,2.7,3.3c0,2.3-1.4,3.4-2.9,3.4
	c-0.9,0-1.7-0.4-2.1-1.2l0,0l-0.1,1.1L109.5,60.7L109.5,60.7z M110.7,58.1c0,0.1,0,0.3,0.1,0.4c0.2,0.8,0.9,1.4,1.7,1.4
	c1.2,0,1.9-1,1.9-2.5c0-1.3-0.7-2.4-1.9-2.4c-0.8,0-1.5,0.5-1.8,1.4c0,0.1-0.1,0.3-0.1,0.5v1.2C110.6,58.1,110.7,58.1,110.7,58.1z
	 M117.4,54.3l1.4,3.8c0.1,0.4,0.3,0.9,0.4,1.3l0,0c0.1-0.4,0.3-0.9,0.4-1.3l1.3-3.7h1.2l-1.7,4.5c-0.8,2.2-1.4,3.3-2.2,4
	c-0.6,0.5-1.1,0.7-1.4,0.8l-0.3-1c0.3-0.1,0.7-0.3,1-0.6s0.7-0.7,1-1.3c0.1-0.1,0.1-0.2,0.1-0.3s0-0.2-0.1-0.3l-2.4-5.9H117.4z
	 M127.5,57.9l-0.9,2.8h-1.2l3-8.9h1.4l3,8.9h-1.2l-0.9-2.8L127.5,57.9L127.5,57.9z M130.4,57l-0.9-2.6l-0.5-1.6l-0.4,1.6l-0.9,2.6
	H130.4L130.4,57z M134,51.3h1.2v9.4H134V51.3z M140.7,60.7l-0.1-0.8c-0.4,0.5-1,0.9-2,0.9c-1.3,0-2-0.9-2-1.8c0-1.5,1.4-2.4,3.8-2.4
	v-0.1c0-0.5-0.1-1.5-1.5-1.5c-0.6,0-1.2,0.2-1.7,0.5l-0.3-0.8c0.5-0.3,1.3-0.6,2.1-0.6c2,0,2.4,1.3,2.4,2.6v2.4c0,0.6,0,1.1,0.1,1.5
	L140.7,60.7L140.7,60.7L140.7,60.7z M140.5,57.4c-1.3,0-2.7,0.2-2.7,1.4c0,0.8,0.5,1.1,1.1,1.1c0.8,0,1.4-0.5,1.5-1.1
	c0-0.1,0.1-0.3,0.1-0.4L140.5,57.4L140.5,57.4z M148.1,60.5c-0.3,0.2-1,0.4-1.8,0.4c-1.9,0-3.2-1.3-3.2-3.3s1.3-3.4,3.4-3.4
	c0.7,0,1.3,0.2,1.6,0.3l-0.3,0.9c-0.3-0.2-0.7-0.3-1.3-0.3c-1.5,0-2.3,1.1-2.3,2.4c0,1.5,0.9,2.4,2.2,2.4c0.7,0,1.1-0.2,1.4-0.3
	L148.1,60.5L148.1,60.5z M149.4,51.3h1.2v4c0.2-0.3,0.5-0.6,0.8-0.8s0.8-0.3,1.2-0.3c0.9,0,2.2,0.5,2.2,2.7v3.8h-1.2V57
	c0-1-0.4-1.9-1.5-1.9c-0.8,0-1.3,0.5-1.6,1.2c-0.1,0.2-0.1,0.3-0.1,0.6v3.8h-1.2v-9.4L149.4,51.3L149.4,51.3z M158,52.5
	c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7l0,0c0-0.4,0.3-0.7,0.7-0.7l0,0C157.8,51.8,158,52.1,158,52.5z M156.7,60.7v-6.4h1.2v6.4
	H156.7z M159.7,59.5c0.3,0.2,0.9,0.5,1.5,0.5c0.8,0,1.2-0.4,1.2-0.9c0-0.6-0.3-0.9-1.2-1.2c-1.1-0.4-1.7-1-1.7-1.8
	c0-1,0.8-1.9,2.2-1.9c0.6,0,1.2,0.2,1.6,0.4l-0.3,0.8c-0.3-0.2-0.7-0.4-1.3-0.4c-0.7,0-1.1,0.4-1.1,0.9s0.4,0.8,1.2,1.1
	c1.1,0.4,1.7,1,1.7,1.9c0,1.1-0.9,1.9-2.4,1.9c-0.7,0-1.3-0.2-1.8-0.4L159.7,59.5L159.7,59.5z M170.8,57.5c0,2.4-1.6,3.4-3.2,3.4
	c-1.7,0-3.1-1.3-3.1-3.3c0-2.1,1.4-3.4,3.2-3.4C169.6,54.2,170.8,55.5,170.8,57.5z M165.8,57.5c0,1.4,0.8,2.5,1.9,2.5s1.9-1,1.9-2.5
	c0-1.1-0.5-2.5-1.9-2.5S165.8,56.3,165.8,57.5z M172.4,60.7v-5.5h-0.9v-0.9h0.9V54c0-0.9,0.2-1.7,0.7-2.2c0.4-0.4,1-0.6,1.6-0.6
	c0.4,0,0.8,0.1,1,0.2l-0.2,0.9c-0.2-0.1-0.4-0.1-0.7-0.1c-1,0-1.2,0.9-1.2,1.8v0.3h1.5v0.9h-1.5v5.5L172.4,60.7L172.4,60.7z
	 M177.7,52.5v1.8h1.7v0.9h-1.7v3.4c0,0.8,0.2,1.2,0.9,1.2c0.3,0,0.5,0,0.7-0.1l0.1,0.9c-0.2,0.1-0.6,0.2-1,0.2c-0.5,0-1-0.2-1.3-0.5
	s-0.4-0.9-0.4-1.7v-3.5h-1v-0.9h1v-1.5L177.7,52.5L177.7,52.5z"/>
        </svg>

      </a>       
        </div>
        
        <div class="row">
          <div class="col-md-12">
            <p><strong>Quotation Id :</strong> {{ this.quotationId != '' ? this.quotationId : '---' }}</p>
            <p><strong>Date Due:</strong> {{showExpryDate() }}</p>
          </div>
        </div>
    
        <hr>
    
        <div class="row">
          <div class="col-md-4">
            <h5>From</h5>
            <p><strong>{{ alachisoftData.name }}</strong></p>
            <p>{{ alachisoftData.address }}</p>
            <p>{{ alachisoftData.phone }}</p>
          </div>
          <div class="col-md-4">
            <h5>Bill To</h5>
            <p><strong>{{ userDetails?.companyDetails?.name }}</strong></p>
            <p>{{userDetails?.companyDetails?.state}}, {{userDetails?.companyDetails?.city}}, {{userDetails?.companyDetails?.country}}, {{userDetails?.companyDetails?.postalCode }}</p>
            <p>{{ userDetails?.primaryUser?.phoneNumber }}</p>
            <p>{{ userDetails?.primaryUser?.email }}</p>
          </div>
          <div class="col-md-4">
            <h5>Ship To</h5>
            <p><strong>{{ userDetails?.companyDetails?.name }}</strong></p>
            <p>{{userDetails?.companyDetails?.state}}, {{userDetails?.companyDetails?.city}}, {{userDetails?.companyDetails?.country}}, {{userDetails?.companyDetails?.postalCode }}</p>
            <p>{{ userDetails?.primaryUser?.phoneNumber }}</p>
          </div>
        </div>
    
        <hr>
    
      <div class="row mt-4">
        <div class="col-md-12">
          <app-nonhosted-quotation-table
          [isPreviewMode]="true"
          [finalCost]="previewFinalCost"
          [previewInvoiceData]="previewData"
          [previewInvoiceDataCost]="previewFinalCost"
          [subscriptionId]="subscriptionId"
          >
          </app-nonhosted-quotation-table>
        </div>
      </div>
    </div>

  </div>
  
  <div class="footer bg-light" *ngIf="toggleButtons()" fxLayoutGap="25px">
    <button
    *ngIf="!togglePreviousButton()"
      class="btn btn-sm btn-nc btn-outline-primary me-3 btn-width"
      (click)="goToPreviousScreen()"
        >
        Previous
    </button>

    <button
    class="btn btn-sm btn-nc btn-primary me-3 btn-width"
    [disabled] = "getQuotationStatus()"
    [ngClass]="{'btn-secondary':getQuotationStatus()}"
    (click)="openQuotationConfirmPopup()"
    [disabled]="getQuotationStatus()"
      >
        Approve
    </button>

    <button
        class="btn btn-sm btn-nc btn-outline-primary me-3 btn-width"
        [routerLink]="['/subscription/dashboard']">
        Close
    </button>
  </div>
